import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Property form
 */

export class PropertyGroupForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Название',
      name: 'title',
      required: true
    }, {
      label: 'Позиция',
      name: 'sort'
    }];
    this.dispatchCreateForm = DispatchSelector.properties.propertiesGroups.create;
    this.dispatchUpdateForm = DispatchSelector.properties.propertiesGroups.update;
    this.responseCreateState = StateSelector.properties.propertiesGroups.create;
    this.responseUpdateState = StateSelector.properties.propertiesGroups.update;
  }

}